module.exports = __webpack_public_path__ + "static/img/banner.5becea02.png";